export default __webpack_public_path__ + "static/media/cr.96cca329.svg";